import { Popconfirm, notification, Button } from 'antd'
import type { NotificationArgsProps } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'

import { useUnit } from 'effector-react'
import {
  $disableAutoWithdrawalRequest,
  submitDisableAutoWithdrawal,
} from 'src/pages/billing/withdrawals/edit/model'

type NotificationPlacement = NotificationArgsProps['placement']
type Props = {
  transactionId: string
}
export const DisableAutoWithdrawalButton = ({ transactionId }: Props) => {
  const [open, setOpen] = useState(false)
  const [api, contextHolder] = notification.useNotification()

  const { loading, success, error } = useUnit($disableAutoWithdrawalRequest)

  const openNotification = (
    type: 'success' | 'info' | 'warning' | 'error',
    placement: NotificationPlacement,
    description: string,
  ) => {
    api[type]({
      message: type,
      placement,
      description,
      key: 'disable-autowithdrawal',
    })
  }

  const showPopconfirm = () => setOpen(true)
  const cancel = () => setOpen(false)
  const confirm = () => {
    submitDisableAutoWithdrawal({ transactionId })
    setOpen(false)
  }

  useEffect(() => {
    if (success) {
      openNotification(
        'success',
        'topRight',
        'Auto withdrawal disabled successfully',
      )
    }
  }, [success])

  useEffect(() => {
    if (error) {
      openNotification('error', 'topRight', `${error}`)
    }
  }, [error])

  return (
    <>
      {contextHolder}
      <Popconfirm
        title="Disable auto withdrawal for this transaction?"
        okText="Yes"
        cancelText="No"
        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
        placement="topRight"
        open={open}
        onConfirm={confirm}
        onCancel={cancel}
      >
        <Button
          type="primary"
          onClick={showPopconfirm}
          style={{ alignSelf: 'flex-start' }}
          loading={loading}
        >
          Disable Auto Withdrawal
        </Button>
      </Popconfirm>
    </>
  )
}
